import { useEffect, useState } from "react";
import { isProfileApproved } from "../helperFunctions";
import { useFetchAllApprovalsSummaryQuery } from "../redux/features/cooperative/cooperative.api";
import { useAppSelector } from "../redux/hooks";

type SingleNav = {
  icon: string;
  mobileIcon?: string;
  mobileActiveIcon?: string;
  title: string;
  to: string;
  hasCount: boolean;
  count?: number;
};

const cooperativeNavs: SingleNav[] = [
  {
    icon: "overview-icon",
    mobileIcon: "nav-home-inact",
    mobileActiveIcon: "nav-home-act",
    title: "Dashboard",
    to: "/app/overview",
    hasCount: false,
    count: undefined,
  },
  {
    icon: "settings",
    mobileIcon: "nav-gear-inact",
    mobileActiveIcon: "nav-gear-act",
    title: "Settings",
    to: "/app/settings",
    hasCount: false,
    count: undefined,
  },
];

const memberNavs: SingleNav[] = [
  {
    icon: "overview-icon",
    mobileIcon: "nav-home-inact",
    mobileActiveIcon: "nav-home-act",
    title: "Dashboard",
    to: "/app/overview",
    hasCount: false,
    count: undefined,
  },

  {
    icon: "people",
    mobileIcon: "nav-coop-inact",
    mobileActiveIcon: "nav-coop-act",
    title: "Cooperatives",
    to: "/app/my-cooperatives",
    hasCount: false,
    count: undefined,
  },

  {
    icon: "settings",
    mobileIcon: "nav-gear-inact",
    mobileActiveIcon: "nav-gear-act",
    title: "Settings",
    to: "/app/settings",
    hasCount: false,
    count: undefined,
  },
];

export const useNavs = () => {
  const [navs, setNavs] = useState<SingleNav[]>([]);

  const { profile, approvalCount, isOfficial } = useAppSelector((state) => {
    return state.auth;
  });

  useFetchAllApprovalsSummaryQuery(undefined, {
    refetchOnMountOrArgChange: true,
    skip: profile?.type !== "member",
    pollingInterval: 60000,
  });

  useEffect(() => {
    // SET NAVIGATION MENUS
    if (profile?.type === "cooperative") {
      setNavs(
        !isProfileApproved(profile)
          ? cooperativeNavs.slice(0, 1)
          : cooperativeNavs
      );
    } else {
      setNavs(
        !isProfileApproved(profile)
          ? memberNavs.slice(0, 1)
          : [
              ...memberNavs.slice(0, 1),
              ...(isOfficial
                ? [
                    {
                      icon: "verified-2",
                      mobileIcon: "nav-app-inact",
                      mobileActiveIcon: "nav-app-act",
                      title: "Approvals",
                      to: "/app/approvals",
                      hasCount: true,
                      count: approvalCount,
                    },
                  ]
                : []),
              ...memberNavs.slice(1),
            ]
      );
    }
  }, [profile, approvalCount, isOfficial]);

  return { navs };
};
